import { tr } from "./language";
const IBAN_RE = /^[A-Z]{2}\d{2}[A-Z0-9]{11,30}$/;
const SWIFT_RE = /^[A-Z]{6}[A-Z0-9]{2}(?:[A-Z0-9]{3})?$/;
const NAME_RE = /^[\p{L}\p{M}\d &'.,()\/+\-]+$/u;
const CITY_RE = /^[\p{L}\p{M} .'-]+$/u;
const ADDRESS_RE = /^[\p{L}\p{M}\d\s&'.,#()\/+\-]+$/u;
const POSTAL_RE = /^[A-Z0-9][A-Z0-9 -]{1,19}$/;

export const normalizeIban = (value = "") =>
  value.replace(/\s/g, "").toUpperCase();

export const isValidIban = (value) => {
  const iban = normalizeIban(value);
  if (!IBAN_RE.test(iban)) return false;

  const rearranged = `${iban.slice(4)}${iban.slice(0, 4)}`;
  let remainder = 0;
  for (const character of rearranged) {
    const digits = /\d/.test(character)
      ? character
      : String(character.charCodeAt(0) - 55);
    for (const digit of digits) remainder = (remainder * 10 + Number(digit)) % 97;
  }
  return remainder === 1;
};

export const validateBankDetails = (form = {}) => {
  const errors = {};
  const iban = normalizeIban(form.iban);
  const swift = (form.swift || "").replace(/\s/g, "").toUpperCase();
  const beneficiary = (form.beneficiary_name || "").trim();
  const bankName = (form.bank_name || "").trim();

  if (!iban) errors.iban = "IBAN is required.";
  else if (!isValidIban(iban)) errors.iban = tr("Enter a valid IBAN, including its checksum.");

  if (!swift) errors.swift = "SWIFT / BIC is required.";
  else if (!SWIFT_RE.test(swift)) errors.swift = "SWIFT / BIC must contain 8 or 11 valid characters.";

  if (!beneficiary) errors.beneficiary_name = tr("Beneficiary name is required.");
  else if (beneficiary.length > 160 || !NAME_RE.test(beneficiary)) errors.beneficiary_name = tr("Enter a valid beneficiary name.");

  if (!bankName) errors.bank_name = tr("Bank name is required.");
  else if (bankName.length > 160 || !NAME_RE.test(bankName)) errors.bank_name = tr("Enter a valid bank name.");

  const accountType = (form.account_type || "").trim();
  if (accountType && (accountType.length > 120 || !NAME_RE.test(accountType))) errors.account_type = tr("Enter a valid account type.");

  const city = (form.bank_city || "").trim();
  if (city && (city.length > 120 || !CITY_RE.test(city))) errors.bank_city = tr("Enter a valid bank city.");

  const address = (form.bank_address || "").trim();
  if (address && (address.length > 300 || !ADDRESS_RE.test(address))) errors.bank_address = tr("Enter a valid bank address.");

  const postal = (form.bank_zip || "").trim().toUpperCase();
  if (postal && !POSTAL_RE.test(postal)) errors.bank_zip = tr("Enter a valid postal or ZIP code.");

  return errors;
};

export const normalizeBankDetails = (form = {}) => ({
  iban: normalizeIban(form.iban),
  swift: (form.swift || "").replace(/\s/g, "").toUpperCase(),
  account_type: (form.account_type || "").trim(),
  beneficiary_name: (form.beneficiary_name || "").trim(),
  bank_city: (form.bank_city || "").trim(),
  bank_name: (form.bank_name || "").trim(),
  bank_address: (form.bank_address || "").trim(),
  bank_zip: (form.bank_zip || "").trim().toUpperCase(),
});
